import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { EasyModal, EasyIcon, EditPage, TreeContext } from 'src/components'

type Props = {
  config: ButtonConfig
}

const AddBtnDiffLevel = (props: Props) => {
  const tree = useContext(TreeContext)

  const formData = useMemo(() => {
    // 新增下级时，要把当前节点的 formId 当作 parentFormId
    const { __RECORD__: record } = props.config
    return { parentFormId: record?.ID }
  }, [props.config.__RECORD__])

  const formCode = tree.treeConfig.Nav_Form?.CODE
  const { LABEL, ICON, WIDTH } = props.config
  return (
    <EasyModal
      modal={{ title: formCode, width: WIDTH }}
      slot={<EasyIcon title={LABEL} type={ICON} defaultIcon='PlusSquareOutlined' />}
      onClose={() => tree.getTreeData()}
    >
      <EditPage formCode={formCode} formData={formData} />
    </EasyModal>
  )
}

export default AddBtnDiffLevel